// extracted by mini-css-extract-plugin
module.exports = {"single-strip":"Hamburger_single-strip__2GY0m","hamburger":"Hamburger_hamburger__3qP0-","dark":"Hamburger_dark__3W_hT","light":"Hamburger_light__2PGsn"};